import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '../../components/components.module';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { CatalogoComponent } from './catalogo.component';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { DetalleModule } from './detalle/detalle.module';

@NgModule({
    declarations:[
        CatalogoComponent
    ],
    imports:[
        ComponentsModule,
        DetalleModule,
        AngularFontAwesomeModule,
        BrowserModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports:[
        CatalogoComponent
    ]
})
export class CatalogoModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }